import axios from 'axios'

export interface IActivityInvite {
    id: number
    activiteitIngeplandId: number
    activiteitNaam: string
    activiteitDatumTijd: string
    lesduur: number
    vanStamgroepNaam: string
    vanGebruikerNaam: string
    naarStamgroepNaam: string
    status: 'Verstuurd' | 'Geaccepteerd' | 'Geweigerd' | 'Verlopen'
    gecreerdeOp: string
    gereageerdOp: string
    bericht: string
}

export default class ActivityInviteService {
    getReceivedActivityInvites(stamgroepId: number) {
        return axios.get<IActivityInvite[]>(`api/Frontend/Jaarplanning/ActiviteitUitnodiging/ontvangen/${stamgroepId}`)
    }
    getSentActivityInvites(stamgroepId: number) {
        return axios.get<IActivityInvite[]>(`api/Frontend/Jaarplanning/ActiviteitUitnodiging/verstuurd/${stamgroepId}`)
    }
    acceptActivityInvite(stamgroepId: number, inviteId: number) {
        return axios.post(`api/Frontend/Jaarplanning/ActiviteitUitnodiging/accepteer`, {
            stamgroepId: stamgroepId,
            uitnodigingId: inviteId,
        })
    }
    rejectActivityInvite(stamgroepId: number, inviteId: number) {
        return axios.post(`api/Frontend/Jaarplanning/ActiviteitUitnodiging/weiger`, {
            stamgroepId: stamgroepId,
            uitnodigingId: inviteId,
        })
    }
    sendActivityInvite({ stamgroepId, activiteitIngeplandId, naarStamgroepId, bericht }: { stamgroepId: number; activiteitIngeplandId: number; naarStamgroepId: number; bericht: string }) {
        return axios.post(`api/Frontend/Jaarplanning/ActiviteitUitnodiging/verstuur`, {
            stamgroepId: stamgroepId,
            activiteitIngeplandId: activiteitIngeplandId,
            naarStamgroepId: naarStamgroepId,
            bericht: bericht,
        })
    }
}

export const activityInviteService = new ActivityInviteService()
